const INDUSTRY_GROUP_LIST = [
  {
    label: 'A/C, Refrigeration Repair',
    value: 7623,
  },
  {
    label: 'Accounting/Bookkeeping Services',
    value: 8931,
  },
  {
    label: 'Advertising Services',
    value: 7311,
  },
  {
    label: 'Agricultural Cooperative',
    value: 763,
  },
  {
    label: 'Airlines, Air Carriers',
    value: 4511,
  },
  {
    label: 'Airports, Flying Fields',
    value: 4582,
  },
  {
    label: 'Ambulance Services',
    value: 4119,
  },
  {
    label: 'Amusement Parks/Carnivals',
    value: 7996,
  },
  {
    label: 'Antique Reproductions',
    value: 5937,
  },
  {
    label: 'Antique Shops',
    value: 5932,
  },
  {
    label: 'Aquariums',
    value: 7998,
  },
  {
    label: 'Architectural/Surveying Services',
    value: 8911,
  },
  {
    label: 'Art Dealers and Galleries',
    value: 5971,
  },
  {
    label: 'Artists Supply and Craft Shops',
    value: 5970,
  },
  {
    label: 'Auto Body Repair Shops',
    value: 7531,
  },
  {
    label: 'Auto Paint Shops',
    value: 7535,
  },
  {
    label: 'Auto Service Shops',
    value: 7538,
  },
  {
    label: 'Auto and Home Supply Stores',
    value: 5531,
  },
  {
    label: 'Automated Cash Disburse',
    value: 6011,
  },
  {
    label: 'Automated Fuel Dispensers',
    value: 5542,
  },
  {
    label: 'Automobile Associations',
    value: 8675,
  },
  {
    label: 'Automotive Parts and Accessories Stores',
    value: 5533,
  },
  {
    label: 'Automotive Tire Stores',
    value: 5532,
  },
  {
    label:
      'Bail and Bond Payments (payment to the surety for the bond, not the actual bond paid to the government agency)',
    value: 9223,
  },
  {
    label: 'Bakeries',
    value: 5462,
  },
  {
    label: 'Bands, Orchestras',
    value: 7929,
  },
  {
    label: 'Barber and Beauty Shops',
    value: 7230,
  },
  {
    label: 'Betting/Casino Gambling',
    value: 7995,
  },
  {
    label: 'Bicycle Shops',
    value: 5940,
  },
  {
    label: 'Billiard/Pool Establishments',
    value: 7932,
  },
  {
    label: 'Boat Dealers',
    value: 5551,
  },
  {
    label: 'Boat Rentals and Leases',
    value: 4457,
  },
  {
    label: 'Book Stores',
    value: 5942,
  },
  {
    label: 'Books, Periodicals, and Newspapers',
    value: 5192,
  },
  {
    label: 'Bowling Alleys',
    value: 7933,
  },
  {
    label: 'Bus Lines',
    value: 4131,
  },
  {
    label: 'Business/Secretarial Schools',
    value: 8244,
  },
  {
    label: 'Buying/Shopping Services',
    value: 7278,
  },
  {
    label: 'Cable, Satellite, and Other Pay Television and Radio',
    value: 4899,
  },
  {
    label: 'Camera and Photographic Supply Stores',
    value: 5946,
  },
  {
    label: 'Candy, Nut, and Confectionery Stores',
    value: 5441,
  },
  {
    label: 'Car Rental Agencies',
    value: 7512,
  },
  {
    label: 'Car Washes',
    value: 7542,
  },
  {
    label: 'Car and Truck Dealers (New & Used) Sales, Service, Repairs Parts and Leasing',
    value: 5511,
  },
  {
    label: 'Car and Truck Dealers (Used Only) Sales, Service, Repairs Parts and Leasing',
    value: 5521,
  },
  {
    label: 'Carpentry Services',
    value: 1750,
  },
  {
    label: 'Carpet/Upholstery Cleaning',
    value: 7217,
  },
  {
    label: 'Caterers',
    value: 5811,
  },
  {
    label: 'Charitable and Social Service Organizations - Fundraising',
    value: 8398,
  },
  {
    label: 'Chemicals and Allied Products (Not Elsewhere Classified)',
    value: 5169,
  },
  {
    label: 'Child Care Services',
    value: 8351,
  },
  {
    label: 'Childrens and Infants Wear Stores',
    value: 5641,
  },
  {
    label: 'Chiropodists, Podiatrists',
    value: 8049,
  },
  {
    label: 'Chiropractors',
    value: 8041,
  },
  {
    label: 'Cigar Stores and Stands',
    value: 5993,
  },
  {
    label: 'Civic, Social, Fraternal Associations',
    value: 8641,
  },
  {
    label: 'Cleaning and Maintenance',
    value: 7349,
  },
  {
    label: 'Clothing Rental',
    value: 7296,
  },
  {
    label: 'Colleges, Universities',
    value: 8220,
  },
  {
    label: 'Commercial Equipment (Not Elsewhere Classified)',
    value: 5046,
  },
  {
    label: 'Commercial Footwear',
    value: 5139,
  },
  {
    label: 'Commercial Photography, Art and Graphics',
    value: 7333,
  },
  {
    label: 'Commuter Transport, Ferries',
    value: 4111,
  },
  {
    label: 'Computer Network Services',
    value: 4816,
  },
  {
    label: 'Computer Programming',
    value: 7372,
  },
  {
    label: 'Computer Repair',
    value: 7379,
  },
  {
    label: 'Computer Software Stores',
    value: 5734,
  },
  {
    label: 'Computers, Peripherals, and Software',
    value: 5045,
  },
  {
    label: 'Concrete Work Services',
    value: 1771,
  },
  {
    label: 'Construction Materials (Not Elsewhere Classified)',
    value: 5039,
  },
  {
    label: 'Consulting, Public Relations',
    value: 7392,
  },
  {
    label: 'Correspondence Schools',
    value: 8241,
  },
  {
    label: 'Cosmetic Stores',
    value: 5977,
  },
  {
    label: 'Counseling Services',
    value: 7277,
  },
  {
    label: 'Country Clubs',
    value: 7997,
  },
  {
    label: 'Courier Services',
    value: 4215,
  },
  {
    label: 'Court Costs, Including Alimony and Child Support - Courts of Law',
    value: 9211,
  },
  {
    label: 'Credit Reporting Agencies',
    value: 7321,
  },
  {
    label: 'Cruise Lines',
    value: 4411,
  },
  {
    label: 'Dairy Products Stores',
    value: 5451,
  },
  {
    label: 'Dance Hall, Studios, Schools',
    value: 7911,
  },
  {
    label: 'Dating/Escort Services',
    value: 7273,
  },
  {
    label: 'Dentists, Orthodontists',
    value: 8021,
  },
  {
    label: 'Department Stores',
    value: 5311,
  },
  {
    label: 'Detective Agencies',
    value: 7393,
  },
  {
    label: 'Digital Goods Media – Books, Movies, Music',
    value: 5815,
  },
  {
    label: 'Digital Goods – Applications (Excludes Games)',
    value: 5817,
  },
  {
    label: 'Digital Goods – Games',
    value: 5816,
  },
  {
    label: 'Digital Goods – Large Digital Goods Merchant',
    value: 5818,
  },
  {
    label: 'Direct Marketing - Catalog Merchant',
    value: 5964,
  },
  {
    label: 'Direct Marketing - Combination Catalog and Retail Merchant',
    value: 5965,
  },
  {
    label: 'Direct Marketing - Inbound Telemarketing',
    value: 5967,
  },
  {
    label: 'Direct Marketing - Insurance Services',
    value: 5960,
  },
  {
    label: 'Direct Marketing - Other',
    value: 5969,
  },
  {
    label: 'Direct Marketing - Outbound Telemarketing',
    value: 5966,
  },
  {
    label: 'Direct Marketing - Subscription',
    value: 5968,
  },
  {
    label: 'Direct Marketing - Travel',
    value: 5962,
  },
  {
    label: 'Discount Stores',
    value: 5310,
  },
  {
    label: 'Doctors',
    value: 8011,
  },
  {
    label: 'Door-To-Door Sales',
    value: 5963,
  },
  {
    label: 'Drapery, Window Covering, and Upholstery Stores',
    value: 5714,
  },
  {
    label: 'Drinking Places',
    value: 5813,
  },
  {
    label: 'Drug Stores and Pharmacies',
    value: 5912,
  },
  {
    label: 'Drugs, Drug Proprietaries, and Druggist Sundries',
    value: 5122,
  },
  {
    label: 'Dry Cleaners',
    value: 7216,
  },
  {
    label: 'Durable Goods (Not Elsewhere Classified)',
    value: 5099,
  },
  {
    label: 'Duty Free Stores',
    value: 5309,
  },
  {
    label: 'Eating Places, Restaurants',
    value: 5812,
  },
  {
    label: 'Educational Services',
    value: 8299,
  },
  {
    label: 'Electric Razor Stores',
    value: 5997,
  },
  {
    label: 'Electrical Parts and Equipment',
    value: 5065,
  },
  {
    label: 'Electrical Services',
    value: 1731,
  },
  {
    label: 'Electronics Repair Shops',
    value: 7622,
  },
  {
    label: 'Electronics Stores',
    value: 5732,
  },
  {
    label: 'Elementary, Secondary Schools',
    value: 8211,
  },
  {
    label: 'Employment/Temp Agencies',
    value: 7361,
  },
  {
    label: 'Equipment Rental',
    value: 7394,
  },
  {
    label: 'Exterminating Services',
    value: 7342,
  },
  {
    label: 'Family Clothing Stores',
    value: 5651,
  },
  {
    label: 'Fast Food Restaurants',
    value: 5814,
  },
  {
    label: 'Financial Institutions',
    value: 6012,
  },
  {
    label: 'Fines - Government Administrative Entities',
    value: 9222,
  },
  {
    label: 'Fireplace, Fireplace Screens, and Accessories Stores',
    value: 5718,
  },
  {
    label: 'Floor Covering Stores',
    value: 5713,
  },
  {
    label: 'Florists',
    value: 5992,
  },
  {
    label: 'Florists Supplies, Nursery Stock, and Flowers',
    value: 5193,
  },
  {
    label: 'Freezer and Locker Meat Provisioners',
    value: 5422,
  },
  {
    label: 'Fuel Dealers (Non Automotive)',
    value: 5983,
  },
  {
    label: 'Funeral Services, Crematories',
    value: 7261,
  },
  {
    label: 'Furniture Repair, Refinishing',
    value: 7641,
  },
  {
    label: 'Furniture, Home Furnishings, and Equipment Stores, Except Appliances',
    value: 5712,
  },
  {
    label: 'Furriers and Fur Shops',
    value: 5681,
  },
  {
    label: 'General Services',
    value: 1520,
  },
  {
    label: 'Gift, Card, Novelty, and Souvenir Shops',
    value: 5947,
  },
  {
    label: 'Glass, Paint, and Wallpaper Stores',
    value: 5231,
  },
  {
    label: 'Glassware, Crystal Stores',
    value: 5950,
  },
  {
    label: 'Golf Courses - Public',
    value: 7992,
  },
  {
    label: 'Government Services (Not Elsewhere Classified)',
    value: 9399,
  },
  {
    label: 'Grocery Stores, Supermarkets',
    value: 5411,
  },
  {
    label: 'Hardware Stores',
    value: 5251,
  },
  {
    label: 'Hardware, Equipment, and Supplies',
    value: 5072,
  },
  {
    label: 'Health and Beauty Spas',
    value: 7298,
  },
  {
    label: 'Hearing Aids Sales and Supplies',
    value: 5975,
  },
  {
    label: 'Heating, Plumbing, A/C',
    value: 1711,
  },
  {
    label: 'Hobby, Toy, and Game Shops',
    value: 5945,
  },
  {
    label: 'Home Supply Warehouse Stores',
    value: 5200,
  },
  {
    label: 'Hospitals',
    value: 8062,
  },
  {
    label: 'Hotels, Motels, and Resorts',
    value: 7011,
  },
  {
    label: 'Household Appliance Stores',
    value: 5722,
  },
  {
    label: 'Industrial Supplies (Not Elsewhere Classified)',
    value: 5085,
  },
  {
    label: 'Information Retrieval Services',
    value: 7375,
  },
  {
    label: 'Insurance - Default',
    value: 6399,
  },
  {
    label: 'Insurance Underwriting, Premiums',
    value: 6300,
  },
  {
    label: 'Intra-Company Purchases',
    value: 9950,
  },
  {
    label: 'Jewelry Stores, Watches, Clocks, and Silverware Stores',
    value: 5944,
  },
  {
    label: 'Landscaping Services',
    value: 780,
  },
  {
    label: 'Laundries',
    value: 7211,
  },
  {
    label: 'Laundry, Cleaning Services',
    value: 7210,
  },
  {
    label: 'Legal Services, Attorneys',
    value: 8111,
  },
  {
    label: 'Luggage and Leather Goods Stores',
    value: 5948,
  },
  {
    label: 'Lumber, Building Materials Stores',
    value: 5211,
  },
  {
    label: 'Manual Cash Disburse',
    value: 6010,
  },
  {
    label: 'Marinas, Service and Supplies',
    value: 4468,
  },
  {
    label: 'Masonry, Stonework, and Plaster',
    value: 1740,
  },
  {
    label: 'Massage Parlors',
    value: 7297,
  },
  {
    label: 'Medical Services',
    value: 8099,
  },
  {
    label: 'Medical and Dental Labs',
    value: 8071,
  },
  {
    label: 'Medical, Dental, Ophthalmic, and Hospital Equipment and Supplies',
    value: 5047,
  },
  {
    label: 'Membership Organizations',
    value: 8699,
  },
  {
    label: 'Mens and Boys Clothing and Accessories Stores',
    value: 5611,
  },
  {
    label: 'Mens, Womens Clothing Stores',
    value: 5691,
  },
  {
    label: 'Metal Service Centers',
    value: 5051,
  },
  {
    label: 'Miscellaneous Apparel and Accessory Shops',
    value: 5699,
  },
  {
    label: 'Miscellaneous Auto Dealers',
    value: 5599,
  },
  {
    label: 'Miscellaneous Business Services',
    value: 7399,
  },
  {
    label: 'Miscellaneous Food Stores - Convenience Stores and Specialty Markets',
    value: 5499,
  },
  {
    label: 'Miscellaneous General Merchandise',
    value: 5399,
  },
  {
    label: 'Miscellaneous General Services',
    value: 7299,
  },
  {
    label: 'Miscellaneous Home Furnishing Specialty Stores',
    value: 5719,
  },
  {
    label: 'Miscellaneous Publishing and Printing',
    value: 2741,
  },
  {
    label: 'Miscellaneous Recreation Services',
    value: 7999,
  },
  {
    label: 'Miscellaneous Repair Shops',
    value: 7699,
  },
  {
    label: 'Miscellaneous Specialty Retail',
    value: 5999,
  },
  {
    label: 'Mobile Home Dealers',
    value: 5271,
  },
  {
    label: 'Motion Picture Theaters',
    value: 7832,
  },
  {
    label:
      'Motor Freight Carriers and Trucking - Local and Long Distance, Moving and Storage Companies, and Local Delivery Services',
    value: 4214,
  },
  {
    label: 'Motor Homes Dealers',
    value: 5592,
  },
  {
    label: 'Motor Vehicle Supplies and New Parts',
    value: 5013,
  },
  {
    label: 'Motorcycle Shops and Dealers',
    value: 5571,
  },
  {
    label: 'Motorcycle Shops, Dealers',
    value: 5561,
  },
  {
    label: 'Music Stores-Musical Instruments, Pianos, and Sheet Music',
    value: 5733,
  },
  {
    label: 'News Dealers and Newsstands',
    value: 5994,
  },
  {
    label: 'Non-FI, Money Orders',
    value: 6051,
  },
  {
    label: 'Non-FI, Stored Value Card Purchase/Load',
    value: 6540,
  },
  {
    label: 'Nondurable Goods (Not Elsewhere Classified)',
    value: 5199,
  },
  {
    label: 'Nurseries, Lawn and Garden Supply Stores',
    value: 5261,
  },
  {
    label: 'Nursing/Personal Care',
    value: 8050,
  },
  {
    label: 'Office and Commercial Furniture',
    value: 5021,
  },
  {
    label: 'Opticians, Eyeglasses',
    value: 8043,
  },
  {
    label: 'Optometrists, Ophthalmologist',
    value: 8042,
  },
  {
    label: 'Orthopedic Goods - Prosthetic Devices',
    value: 5976,
  },
  {
    label: 'Osteopaths',
    value: 8031,
  },
  {
    label: 'Package Stores-Beer, Wine, and Liquor',
    value: 5921,
  },
  {
    label: 'Paints, Varnishes, and Supplies',
    value: 5198,
  },
  {
    label: 'Parking Lots, Garages',
    value: 7523,
  },
  {
    label: 'Passenger Railways',
    value: 4112,
  },
  {
    label: 'Pawn Shops',
    value: 5933,
  },
  {
    label: 'Pet Shops, Pet Food, and Supplies',
    value: 5995,
  },
  {
    label: 'Petroleum and Petroleum Products',
    value: 5172,
  },
  {
    label: 'Photo Developing',
    value: 7395,
  },
  {
    label: 'Photographic Studios',
    value: 7221,
  },
  {
    label: 'Photographic, Photocopy, Microfilm Equipment, and Supplies',
    value: 5044,
  },
  {
    label: 'Picture/Video Production',
    value: 7829,
  },
  {
    label: 'Piece Goods, Notions, and Other Dry Goods',
    value: 5131,
  },
  {
    label: 'Plumbing, Heating Equipment, and Supplies',
    value: 5074,
  },
  {
    label: 'Political Organizations',
    value: 8651,
  },
  {
    label: 'Postal Services - Government Only',
    value: 9402,
  },
  {
    label: 'Precious Stones and Metals, Watches and Jewelry',
    value: 5094,
  },
  {
    label: 'Professional Services',
    value: 8999,
  },
  {
    label: 'Public Warehousing and Storage - Farm Products, Refrigerated Goods, Household Goods, and Storage',
    value: 4225,
  },
  {
    label: 'Quick Copy, Repro, and Blueprint',
    value: 7338,
  },
  {
    label: 'Railroads',
    value: 4011,
  },
  {
    label: 'Real Estate Agents and Managers - Rentals',
    value: 6513,
  },
  {
    label: 'Record Stores',
    value: 5735,
  },
  {
    label: 'Recreational Vehicle Rentals',
    value: 7519,
  },
  {
    label: 'Religious Goods Stores',
    value: 5973,
  },
  {
    label: 'Religious Organizations',
    value: 8661,
  },
  {
    label: 'Roofing/Siding, Sheet Metal',
    value: 1761,
  },
  {
    label: 'Secretarial Support Services',
    value: 7339,
  },
  {
    label: 'Security Brokers/Dealers',
    value: 6211,
  },
  {
    label: 'Service Stations',
    value: 5541,
  },
  {
    label: 'Sewing, Needlework, Fabric, and Piece Goods Stores',
    value: 5949,
  },
  {
    label: 'Shoe Repair/Hat Cleaning',
    value: 7251,
  },
  {
    label: 'Shoe Stores',
    value: 5661,
  },
  {
    label: 'Small Appliance Repair',
    value: 7629,
  },
  {
    label: 'Snowmobile Dealers',
    value: 5598,
  },
  {
    label: 'Special Trade Services',
    value: 1799,
  },
  {
    label: 'Specialty Cleaning',
    value: 2842,
  },
  {
    label: 'Sporting Goods Stores',
    value: 5941,
  },
  {
    label: 'Sporting/Recreation Camps',
    value: 7032,
  },
  {
    label: 'Sports Clubs/Fields',
    value: 7941,
  },
  {
    label: 'Sports and Riding Apparel Stores',
    value: 5655,
  },
  {
    label: 'Stamp and Coin Stores',
    value: 5972,
  },
  {
    label: 'Stationary, Office Supplies, Printing and Writing Paper',
    value: 5111,
  },
  {
    label: 'Stationery Stores, Office, and School Supply Stores',
    value: 5943,
  },
  {
    label: 'Swimming Pools Sales',
    value: 5996,
  },
  {
    label: 'TUI Travel - Germany',
    value: 4723,
  },
  {
    label: 'Tailors, Alterations',
    value: 5697,
  },
  {
    label: 'Tax Payments - Government Agencies',
    value: 9311,
  },
  {
    label: 'Tax Preparation Services',
    value: 7276,
  },
  {
    label: 'Taxicabs/Limousines',
    value: 4121,
  },
  {
    label: 'Telecommunication Equipment and Telephone Sales',
    value: 4812,
  },
  {
    label: 'Telecommunication Services',
    value: 4814,
  },
  {
    label: 'Telegraph Services',
    value: 4821,
  },
  {
    label: 'Tent and Awning Shops',
    value: 5998,
  },
  {
    label: 'Testing Laboratories',
    value: 8734,
  },
  {
    label: 'Theatrical Ticket Agencies',
    value: 7922,
  },
  {
    label: 'Timeshares',
    value: 7012,
  },
  {
    label: 'Tire Retreading and Repair',
    value: 7534,
  },
  {
    label: 'Tolls/Bridge Fees',
    value: 4784,
  },
  {
    label: 'Tourist Attractions and Exhibits',
    value: 7991,
  },
  {
    label: 'Towing Services',
    value: 7549,
  },
  {
    label: 'Trailer Parks, Campgrounds',
    value: 7033,
  },
  {
    label: 'Transportation Services (Not Elsewhere Classified)',
    value: 4789,
  },
  {
    label: 'Travel Agencies, Tour Operators',
    value: 4722,
  },
  {
    label: 'Truck StopIteration',
    value: 7511,
  },
  {
    label: 'Truck/Utility Trailer Rentals',
    value: 7513,
  },
  {
    label: 'Typesetting, Plate Making, and Related Services',
    value: 2791,
  },
  {
    label: 'Typewriter Stores',
    value: 5978,
  },
  {
    label: 'U.S. Federal Government Agencies or Departments',
    value: 9405,
  },
  {
    label: 'Uniforms, Commercial Clothing',
    value: 5137,
  },
  {
    label: 'Used Merchandise and Secondhand Stores',
    value: 5931,
  },
  {
    label: 'Utilities',
    value: 4900,
  },
  {
    label: 'Variety Stores',
    value: 5331,
  },
  {
    label: 'Veterinary Services',
    value: 742,
  },
  {
    label: 'Video Amusement Game Supplies',
    value: 7993,
  },
  {
    label: 'Video Game Arcades',
    value: 7994,
  },
  {
    label: 'Video Tape Rental Stores',
    value: 7841,
  },
  {
    label: 'Vocational/Trade Schools',
    value: 8249,
  },
  {
    label: 'Watch/Jewelry Repair',
    value: 7631,
  },
  {
    label: 'Welding Repair',
    value: 7692,
  },
  {
    label: 'Wholesale Clubs',
    value: 5300,
  },
  {
    label: 'Wig and Toupee Stores',
    value: 5698,
  },
  {
    label: 'Wires, Money Orders',
    value: 4829,
  },
  {
    label: 'Womens Accessory and Specialty Shops',
    value: 5631,
  },
  {
    label: 'Womens Ready-To-Wear Stores',
    value: 5621,
  },
  {
    label: 'Wrecking and Salvage Yards',
    value: 5935,
  },
];

export const INDUSTRY_OTHER_OPTION = { label: 'Other', value: 0 };

export default INDUSTRY_GROUP_LIST;
